import { createSelector } from '@reduxjs/toolkit';
import {
  Tabs,
  VIRTUAL_CARD,
  VIRTUAL_CARD_LANDING_PAGE
} from 'common/constants';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { getHarnessFlagValue } from 'pages/LandingPage/slice';
import { getPaymentMethods } from 'pages/VendorsTablePage/components/VendorsTable/slice';
import type { RootState } from 'store/index';

const selectSelf = (state: RootState) => state;

export const getAuthorizeReviewRequest = createSelector(
  selectSelf,
  ({ authorizeReview }) => authorizeReview.authorizePaymentReview
);

export const getVendorInvoiceRecords = createSelector(
  selectSelf,
  ({ authorizeReview: { authorizePaymentReview } }) =>
    authorizePaymentReview.authorizationPaymentList
);

export const getGridApi = createSelector(
  selectSelf,
  ({ authorizeReview }) => authorizeReview.gridApi || null
);

export const getAuthorizeTotal = createSelector(
  getVendorInvoiceRecords,
  selectedVendors =>
    selectedVendors.reduce((total, item) => total + item.netAmount, 0)
);

export const getPayByVirtualCard = createSelector(
  [
    getSelectedTab,
    getPaymentMethods,
    getHarnessFlagValue('dmsAccountingLandingPage')
  ],
  (selectedTab, paymentMethods, landingPageFlag) =>
    selectedTab === Tabs.NeedsAuthorization &&
    paymentMethods?.includes(
      landingPageFlag ? VIRTUAL_CARD_LANDING_PAGE : VIRTUAL_CARD
    )
);
